import Skeleton from 'components/3catinfo/Skeleton/Skeleton';
import styles from './destacatNoticiaAutor.module.scss';

const DestacatNoticiaAutorSkeleton = (props) => {
    return (
        <div>
            <section className={styles.cos}>
                <Skeleton titol className={styles.titol} num={2} />
                <div className={`${styles.imatgeWrapper} ${styles.imatgeSkeleton}`}>
                    <Skeleton imatge />
                </div>
            </section>
        </div>
    );
};

export default DestacatNoticiaAutorSkeleton;
